import { Outlet, useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from '../components/Footer'

function MainLayout() {
  const location = useLocation();

  // Check if the current route is HomePage
  const isHomePage = location.pathname === "/";

  return (
    <div>
      {/* Conditional Header */}
      {/* {isHomePage ? (
        <header className="p-4 bg-orange-100">
          <h1 className="text-lg font-bold">Welcome Back!</h1>
        </header>
      ) : ( */}
        <Header />
      {/* )} */}

      {/* Dynamic Content */}
      <main >
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default MainLayout;
